import React from 'react';
import styled from 'styled-components';
export default function EmailSent({ title, body }) {
    return (React.createElement(AccountFormWrapper, null,
        React.createElement(FormContainer, null,
            React.createElement("a", { href: "/" },
                React.createElement(Img, { src: "/images/icon-white2.png" })),
            React.createElement(MessageHeader, null, title),
            React.createElement(MessageText, null, body))));
}
const AccountFormWrapper = styled.div `
  min-height: calc(100vh - 5px);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0px 18px;
  width: 100%;
  box-sizing: border-box;
  animation: slideupslow 1s ease-out;
`;
const FormContainer = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  padding: 30px 0px;
`;
const MessageHeader = styled.div `
  font-size: 26px;
  font-weight: 600;
  color: white;
  text-align: center;
  margin-bottom: 18px;
  animation: fadein-up 1s ease-in-out;
`;
const MessageText = styled.div `
  text-align: center;
  font-size: 20px;
  line-height: 1.5em;
  max-width: 360px;
  animation: fadein-up 1s ease-in-out;
  color: white;
  opacity: 0.8;
`;
const Img = styled.img `
  width: 140px;
  opacity: 0.9;
  animation: fadein-up 1s ease-in-out;
  margin-bottom: 28px;
  width: 160px;
`;
